import React from 'react';
import styled from 'styled-components';

export default ({ onClick, children, type = 'button', ...props }) => (
  <Button {...props} type={type} onClick={e => {
    e.preventDefault();
    onClick();
  }}>
    {children}
  </Button>
);

const Button = styled.button`
  padding-top: .25rem;
  padding-bottom: .25rem;
  background-color: transparent;
  border: none;
  font-size: .875rem;
  text-align: right;
  text-decoration: underline;
  cursor: pointer;
`;
